import React from 'react';
import { Grid, Container, Box } from '@material-ui/core';
import { HeaderWrapper } from 'components/DetailPageLayout/styles';
import {
  BlocWrapper,
  FullHeightContainer,
  TitleFullHeightGrid,
  BodyWrapperGrid,
} from 'components/DetailPageLayout/styles';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';

const AutoDetailsPage = (props: {
  HeaderTextBloc: React.ReactNode;
  Breadcrumbs: React.ReactNode;
  TabsBloc: React.ReactNode;
  FAQBloc: React.ReactNode;
  CompensationServicesBloc?: React.ReactNode;
  ServiceBloc?: React.ReactNode;
  MyOffersBloc: React.ReactNode;
  headerImage: String;
}) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  return (
    <>
      <HeaderWrapper backgroundImage={props.headerImage} reverse={reverse}>
        <FullHeightContainer>
          <TitleFullHeightGrid
            container
            direction="column"
            justify="flex-end"
            spacing={1}
          >
            <Grid item sm={4}>
              <Box pt={4.75}>{props.HeaderTextBloc}</Box>
            </Grid>
            <Grid item sm={4}>
              <Box pb={[6, 2, 0]}>{props.Breadcrumbs}</Box>
            </Grid>
          </TitleFullHeightGrid>
        </FullHeightContainer>
      </HeaderWrapper>
      <Container>
        <BodyWrapperGrid container spacing={2}>
          <Grid item xs={12} sm={8}>
            <BlocWrapper>{props.TabsBloc}</BlocWrapper>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid container spacing={3} direction="column">
              <Grid item xs>
                <BlocWrapper height="367px">{props.FAQBloc}</BlocWrapper>
              </Grid>
              <Grid item xs>
                <BlocWrapper> {props.CompensationServicesBloc}</BlocWrapper>
              </Grid>
              <Grid item xs>
                {props.ServiceBloc}
              </Grid>
            </Grid>
          </Grid>
        </BodyWrapperGrid>
      </Container>
      <Box paddingTop={5.75}>{props.MyOffersBloc}</Box>
    </>
  );
};

export default AutoDetailsPage;
